import { render, staticRenderFns } from "./listPage.vue?vue&type=template&id=4b20e2f9&scoped=true"
import script from "./listPage.vue?vue&type=script&lang=js"
export * from "./listPage.vue?vue&type=script&lang=js"
import style0 from "./listPage.vue?vue&type=style&index=0&id=4b20e2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20e2f9",
  null
  
)

export default component.exports